import React from 'react'
import { Link } from 'react-router-dom'
import { API, STORAGE_KEYS } from 'src/constants'
import { ArrowLeftIcon } from 'assets/icons'
import { ClientTypes } from 'types'
import { Button, SearchClients, Loader, ClientsTable } from 'components'
import { Http } from 'helpers'

interface Props {
    onSelect: Function
}

interface State {
    keyword: string,
    clients: ClientTypes.Client[]
    loading: boolean,
    searched: boolean,
    selectedClient: ClientTypes.Client | null
}

export default class SelectCustomer extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        const cachedClient =  localStorage.getItem(STORAGE_KEYS.CLIENT)

        this.state = {
            keyword: '',
            loading: false,
            searched: cachedClient ? true : false,
            clients: [],
            selectedClient: cachedClient ? JSON.parse(cachedClient) : null
        }
    }

    public componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('page-product-detail')
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('page-product-detail')
    }

    public handleSearchByKeyword = ( keyword: string ) => {

        this.setState({
            loading: true
        })
        return new Promise( (resolve, reject) => {

            Http(API.host + API.endpoints.clients + '?search=' + keyword )
                .then((result: ClientTypes.Client[]) => {
                    this.setState({
                        keyword: keyword,
                        clients: result,
                        searched: true,
                        loading: false
                    })
                })
                .catch((error) => {
                    console.log(error)
                    reject(error)
                })
        })
    }

    public selectedClient = (client: ClientTypes.Client) => {
        this.setState({
            selectedClient: client
        })
    }

    public emptyResults = (event: any) => {
        localStorage.removeItem(STORAGE_KEYS.CLIENT)
        this.setState({
            keyword: '',
            searched: false,
            clients: [],
            selectedClient: null
        })
    }

    public handleOrderSubmit = () => {
        this.props.onSelect(this.state.selectedClient)
    }

    public render() {

        const { clients, loading, searched, selectedClient } = this.state

        return (
            <section className="page-layout">
                <header className="u-flex u-flex-between">
                    <Link to="/basket" className="button--link u-flex-start">
                        <ArrowLeftIcon fill="#000000"/>
                        Back
                    </Link>
                </header>
                <main>
                    {selectedClient ?
                        <h1 className="u-margin-top--md">Selected <br /> Customer:</h1> :
                        <h1 className="u-margin-top--md">First <br/> select customer:</h1>
                    }
                    {!selectedClient &&
                        <SearchClients
                            value={this.state.keyword}
                            placeholder="Search"
                            onInput={this.handleSearchByKeyword}
                        />
                    }
                    {loading ?
                        <Loader /> :
                        searched &&
                            selectedClient ?
                            <div className="u-margin-top--lg">
                                <h2>{selectedClient.name}</h2>
                                <a
                                    href="#"
                                    className="text-link u-text--centered u-margin-top--lg"
                                    onClick={(event) => this.emptyResults(event)}
                                >(Change)
                                </a>
                            </div>
                            : searched && <ClientsTable items={clients} onSelect={this.selectedClient} />
                    }
                </main>
                <footer>
                    <Button
                        full={true}
                        className="u-margin-top--md"
                        onClick={this.handleOrderSubmit}
                        disabled={selectedClient === null}
                    >Order
                    </Button>
                </footer>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/SelectCustomer/index.tsx